<app-slide-in-right-modal
  [modalTitle]="'Create Minor Account'"
  iconImageSrc="assets/images/svgs/document--outline.svg"
  [returnPath]="returnPathUrl"
  [slideOpen]="true"
>
  <div class="page__container flex flex-col pb-8">
    <form
      class="flex flex-col gap-5"
      [formGroup]="minorForm"
      (ngSubmit)="submit()"
    >

      <!-- First Name -->
      <div>
        <app-input-label
          labelFor="first-name"
          labelClass="label--bottom-margin"
          [isRequired]="true"
          >First Name</app-input-label
        >
        <app-input
          placeholder="Enter Minor's First Name..."
          inputClass="input--padding"
          formControlName="first_name"
        ></app-input>
      </div>

      <!-- Last Name -->
      <div>
        <app-input-label
          labelFor="last-name"
          labelClass="label--bottom-margin"
          [isRequired]="true"
          >Last Name</app-input-label
        >
        <app-input
          placeholder="Enter Minor's Last Name..."
          inputClass="input--padding"
          formControlName="last_name"
        ></app-input>
      </div>

      <!-- DOB & Gender-->
      <div class="grid xl:grid-cols-2 gap-x-5 gap-y-5">
        <div>
          <app-input-label [isRequired]="true" labelClass="label--bottom-margin">Date of Birth</app-input-label>
          <input
            type="date"
            [min]="minDate"
            [max]="maxDate"
            formControlName="dob"
            class="block w-full rounded-lg border-0 pl-2 text-base text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-mango"
          />
        </div>

        <div>
          <app-input-label [isRequired]="true" labelClass="label--bottom-margin">Gender</app-input-label>
          <select required base-select formControlName="gender">
            <option value="" disabled>Select Gender</option>
            <option *ngFor="let gender of genderList" [value]="gender.value">
              {{ gender.label }}
            </option>
          </select>
        </div>
      </div>

      <!-- Phone Numbers -->
      <div class="grid xl:grid-cols-2 gap-x-5 gap-y-5">
        <div>
          <app-input-label labelFor="phone-number" labelClass="label--bottom-margin">Phone Number 1</app-input-label>
          <div class=" relative rounded-lg shadow-sm">
            <input type="text" name="phone-number-1" formControlName="phone_number_1"
              class="block w-full rounded-lg border-0 text-base text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-mango sm:leading-6"
              placeholder="0901234567" maxlength="11" inputmode="numeric"/>
            
            <!-- Loading indicator -->
            <div
              *ngIf="isCheckingPhone1"
              class="absolute right-2 top-1/2 -translate-y-1/2"
            >
              <span class="text-gray-400 text-sm">Checking...</span>
            </div>
          </div>
          <div
            *ngIf="minorForm.get('phone_number_1')?.hasError('phoneExists')"
            class="text-red-500 text-sm mt-1"
          >
            Phone number already exists
          </div>
          <div
            *ngIf="minorForm.get('phone_number_1')?.hasError('serverError')"
            class="text-red-500 text-sm mt-1"
          >
            Phone number already exists
          </div>
        </div>

        <div>
          <app-input-label labelFor="phone-number" labelClass="label--bottom-margin">Phone Number 2</app-input-label>
          <div class="relative rounded-lg shadow-sm">
            <input type="text" name="phone-number-2" formControlName="phone_number_2"
              class="block w-full rounded-lg border-0 text-base text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-mango sm:leading-6"
              placeholder="0901234567" maxlength="11" inputmode="numeric"/>
            
            <!-- Loading indicator -->
            <div
              *ngIf="isCheckingPhone2"
              class="absolute right-2 top-1/2 -translate-y-1/2"
            >
              <span class="text-gray-400 text-sm">Checking...</span>
            </div>
          </div>
          <div
            *ngIf="minorForm.get('phone_number_2')?.hasError('phoneExists')"
            class="text-red-500 text-sm mt-1"
          >
            Phone number already exists
          </div>
          <div
            *ngIf="minorForm.get('phone_number_2')?.hasError('serverError')"
            class="text-red-500 text-sm mt-1"
          >
            Phone number already exists
          </div>
        </div>
      </div>

      <!-- Email -->
      <div>
        <app-input-label
          labelFor="email"
          labelClass="label--bottom-margin"
          >Email</app-input-label
        >
        <div class="relative rounded-lg shadow-sm">
          <app-input
            placeholder="Enter Minor's Email Adress..."
            inputClass="input--padding"
            formControlName="email"
          ></app-input>

          <div
            *ngIf="isCheckingEmail"
            class="absolute right-2 top-1/2 -translate-y-1/2"
          >
            <span class="text-gray-400 text-sm">Checking...</span>
          </div>
        </div>

        <div
          *ngIf="minorForm.get('email')?.hasError('emailExists')"
          class="text-red-500 text-sm mt-1"
        >
          Email already exists
        </div>
        <div
          *ngIf="minorForm.get('email')?.hasError('serverError')"
          class="text-red-500 text-sm mt-1"
        >
          Unable to verify email
        </div>
      </div>

      <button
        type="submit"
        mango-button
        class="w-fit shrink-0 items-center justify-end"
        [disabled]="
          isLoading ||
          minorForm.invalid ||
          minorForm.pending ||
          isCheckingPhone1 ||
          isCheckingPhone2 ||
          isCheckingEmail
        "
      >
        @if (isLoading) {
          <span spin></span>
        } @else {
          <span>Submit</span>
        }
      </button>
    </form>
  </div>
</app-slide-in-right-modal>